import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { I18n, setLocale } from 'react-redux-i18n'

import { Modal, Form, Input, Button, Spin, Select, message, Switch,Radio,InputNumber } from 'antd'
import { MinusCircleOutlined, EditOutlined, PlusOutlined, AppstoreAddOutlined } from '@ant-design/icons';

import * as ToolRequest from '../../tools/ToolRequest'
import SpinFull from '../../components/SpinFull'

const formLayout = {
  labelCol: {
    md: {span: 5},
    sm: {span: 24},
  },
  wrapperCol: {
    md: {span: 16},
  },
}

const formTailLayout = {
  wrapperCol: {
    md: {offset: 5, span: 16},
  },
}

const {TextArea} = Input
const {Option} = Select

export default function ShopInventoryEditModal (props) {
  const userData = useSelector(state => state.user.value)
  const metadata = useSelector(state => state.metadata.value)
  const {shopInventoryId,visible, onOk, onCancel} = props
  const [loaded, setLoaded] = useState(false)
  const [loading, setLoading] = useState(false)
  const [shopInventory, setShopInventory] = useState(null)

  useEffect(() => {
    (async () => {
      try {
        const shopRes = await ToolRequest.request('GET', `/shop`)
        const shopInventoryRes = await ToolRequest.request('GET', `/shop-inventory/${shopInventoryId}`,{includeProduct:true})
        let data = shopInventoryRes.data
        console.dir(data)
        if(data.product){
          data.productName = data.product.name[userData.locale]
        }
        const shops = shopRes.data
        console.dir(shops)
        if(data.shopId){
          const shop = shops.find(item=>item.id === data.shopId)
          console.dir(shop)
          data.shopName = shop.name[userData.locale]
        }
        console.dir(data)
        setShopInventory(data)
      } catch (e) {
        message.error(e)
      }
      setLoaded(true)
    })()
  }, [])

  const onFinish = async (values) => {
    setLoading(true)
    console.dir(values)
    try {
      const data = {
        shopId:shopInventory.shopId,
        productId:shopInventory.productId,
        amount: values.newAmount,
        description: values.description,
      }
      await ToolRequest.request('POST', `/shop-replenish-record`, data)
      message.success(I18n.t('editSuccessMessage'))
      onOk()
      setLoading(false)
    } catch (err) {
      console.dir(err)
      setLoading(false)
      if (err?.response?.data) {
        switch (err.response.data) {
          default:
            return message.error(I18n.t('errorMessageUnknownError'))
        }
      }

      message.error(I18n.t('errorMessageUnknownError'))
    }
  }

  return (
    <Modal
      title={I18n.t('更新庫存')}
      open={visible}
      onCancel={onCancel}
      width="50%"
      maskClosable={false}
      footer={null}
    >
      {loaded ? (
        <Spin spinning={loading}>
          <Form
            {...formLayout}
            initialValues={{
              ...shopInventory,
              // newAmount:0
            }}
            onFinish={onFinish}
          >
            <Form.Item
              label={I18n.t('店铺')}
              name="shopName"
            >
              <Input
                placeholder={I18n.t('店铺')}
                disabled
              />
            </Form.Item>
            <Form.Item
              label={I18n.t('產品')}
              name="productName"
            >
              <Input
                placeholder={I18n.t('產品')}
                disabled
              />
            </Form.Item>
            <Form.Item
              label={I18n.t('原來數量')}
              name="amount"
            >
              <Input
                placeholder={I18n.t('原來數量')}
                disabled
              />
            </Form.Item>
            <Form.Item
              label={I18n.t('数量 (+ -)')}
              name="newAmount"
              rules={[
                {
                  required: true
                },
              ]}
            >
              <InputNumber
                placeholder={I18n.t('数量 (+ -)')}
                step={1} style={{ width: 200 }}
              />
            </Form.Item>
            <Form.Item
              label={I18n.t('操作類別')}
              name="description"
              rules={[
                {
                  required: true
                },
              ]}
            >
              <Select placeholder={I18n.t('操作類別')}>
                <Option value="NORMAL">
                  {I18n.t('出入貨')}
                </Option>
                <Option value="ADJUSTMENT">
                  {I18n.t('盤點')}
                </Option>
              </Select>
            </Form.Item>
            <Form.Item {...formTailLayout}>
              <Button type="primary" htmlType="submit" block>
                {I18n.t('提交')}
              </Button>
            </Form.Item>
          </Form>
        </Spin>
      ) : <SpinFull/>}
    </Modal>
  )
};